import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AcTranslationService } from '@core/services/translation/ac-translation.service';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { userSelectors } from '@store/selectors/user.selectors';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { PortugalHelp } from '@shared/constants/portugal-help';

@Component({
  selector: 'ac-portuguese-spanish-policy',
  standalone: true,
  imports: [RouterLink, NgTemplateOutlet],
  templateUrl: './portuguese-spanish-policy.component.html',
  styles: `
    :host {
      display: block;
    }
  `,
  host: {
    class: 'parsed-html',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortugueseSpanishPolicyComponent {
  protected readonly _currentLangSig = inject(AcTranslationService).langSig;
  protected readonly _phoneNumber = PortugalHelp.PHONE_COMERCIAL;
  protected readonly _protectDataContactEmail = 'protecciondedatosenergia@acciona.com';
  protected readonly _helpEmailSig = inject(Store<StoreState>).selectSignal(userSelectors.helpEmail);
  protected readonly _thirdPartyEuClausesWeb =
    'https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/standard-contractual-clauses-scc_es';

  protected readonly _cookiesRoute = AcRoutingService.COOKIES_ROUTE();
}
